module.exports = __webpack_public_path__ + "static/media/Logo.ace0b297.png";